import $ from 'jquery';

// Expose jQuery for non-ES6 modules
window.jQuery = window.$ = $;

export default $;
